import { DateFormatter } from "./DateFormatter";

export class FuzzyDate {
  constructor(public value: Date | string, public isTime: boolean, public linkedDate: Date = null) {
  }

  get isFuzzy() {
    // string型かnullの場合trueとする.
    return !(this.value instanceof Date);
  }

  get date(): Date {
    // string型の場合はnullを返す.
    return (this.value instanceof Date)
      ? this.value
      : null;
  }

  toString(format: string = "YYYY/MM/DD", manualFormat: string = null, manualFormatLanguage: string = null): string {
    if (typeof this.value === "string") {
      return this.value;
    }
    return DateFormatter.format(this.value, format, manualFormat, manualFormatLanguage);
  }

  public clone(): FuzzyDate {
    return new FuzzyDate(this.value, this.isTime, this.linkedDate);
  }

  public get isEmptyOrZeroLength(): boolean {
    return !this.value;
  }

  public get isEmpty(): boolean {
    return (this.value === null || this.value === undefined);
  }
}
